import { useRoute } from '@react-navigation/native';
import React, { useCallback } from 'react';

import CoGuardianProfileContent from '@/features/guardian-player/components/co-guardian-profile';
import { useGuardianStackNavigation } from '@/hooks';
import type { GuardianStackScreenProps } from '@/navigations/types';

/**
 * Phone Co-Guardian Profile screen. Reached from the Guardian Circle when a primary
 * guardian taps an already-joined co-guardian. On tablet this content renders in the
 * circle's right pane instead (BR-03), so this screen is phone-only.
 */
const CoGuardianProfileScreen = () => {
  const navigation = useGuardianStackNavigation();
  const route = useRoute<GuardianStackScreenProps<'CoGuardianProfile'>['route']>();
  const { player, guardianUid, isPrimaryGuardian } = route.params;

  const handleRemove = useCallback(() => {
    if (!guardianUid) return;
    navigation.navigate('RemoveCoGuardian', { player, guardianUid });
  }, [navigation, player, guardianUid]);

  return (
    <CoGuardianProfileContent
      player={player}
      guardianUid={guardianUid}
      onBack={navigation.goBack}
      isPrimaryGuardian={isPrimaryGuardian}
      onRemove={handleRemove}
    />
  );
};

export default CoGuardianProfileScreen;
